import { render, staticRenderFns } from "./irrigationInfo.vue?vue&type=template&id=4997d166&scoped=true"
import script from "./irrigationInfo.vue?vue&type=script&lang=js"
export * from "./irrigationInfo.vue?vue&type=script&lang=js"
import style0 from "./irrigationInfo.vue?vue&type=style&index=0&id=4997d166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4997d166",
  null
  
)

export default component.exports